import React from 'react';
import { RepublicDay2025 } from '../views';

const AccountGeneralPage = () => {
  return <RepublicDay2025/>;
};

export default AccountGeneralPage;